import { z } from "zod";

export const playlistSchema = z.object({
  name: z.string().min(1, "Name is required"),
  type: z.enum(["main", "sub"]),
  isActive: z.boolean().optional(),
  tagIds: z.array(z.string()).optional(),
  media: z.array(z.any()).optional(),
});

export const playlistFilterSchema = z.object({
  type: z.enum(["main", "sub"]).optional(),
  tag: z.string().optional(),
});

export type PlaylistFormData = z.infer<typeof playlistSchema>;
export type PlaylistFilterFormData = z.infer<typeof playlistFilterSchema>;

export interface MediaInput {
  id: string;
  count?: number;
}

export interface PlaylistMedia {
  id: string;
  itemId?: string;
  count?: number;
}

export interface Playlist {
  id: string;
  name: string;
  type: string;
  duration: number;
  isActive: boolean;
  tenantId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
  creatives?: any[];
  subPlaylists?: Playlist[];
  tags?: string;
  tagIds: string[];
  isClientPlaylist: boolean;
  screenId?: string | null;
  media?: PlaylistMedia[]; // For playlist assignments (client-side usage)
}

export interface PlaylistResult {
  playlists: Playlist[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface PlaylistResponse {
  data: Playlist[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface AssignmentResult {
  id: string;
  playlistId: string;
  itemId: string;
  repetitionCount: number;
  playOrder: number | null;
  name?: string;
  fileUrl?: string;
  thumbnailUrl?: string;
  duration?: number;
  /** Outside its flight window: greyed and badged "Paused" in the portal. */
  isPaused?: boolean;
}

export interface PlaylistFilters {
  page?: number;
  pageSize?: number;
  search?: string;
  type?: "main" | "sub" | "client";
  tagIds?: string[];
  tag?: string; // For backward compatibility with filter form
}

export type UpdatePlaylistPayload = {
  id: string;
  playlist: {
    name?: string;
    type?: string;
    isActive?: boolean;
    tagIds?: string[];
  };
};

export type ClonePlaylistPayload = {
  id: string;
  name: string;
};
